export function LoadingSpinner() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <div
        className="h-6 w-6 animate-spin rounded-full border-2 border-ink/20 border-t-neutral-700 dark:border-ink/20 dark:border-t-neutral-300"
        aria-hidden="true"
      />
      <span className="sr-only">Loading</span>
    </div>
  );
}
